import { router } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import logoImage from '@/assets/logo.png';

interface Props {
  token: string;
}

export default function ConfirmEmailVerification({ token }: Props) {
  const handleConfirm = () => {
    router.post(`/email_verification/verify/${token}`);
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-8 px-4">
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <img src={logoImage} alt="Project Short" className="h-12 w-auto" />
          </div>

          <h1 className="text-3xl font-semibold text-gray-900">
            Account Confirmation
          </h1>

          <p className="text-gray-600">
            To confirm your account, please click the button below.
          </p>

          <Button
            onClick={handleConfirm}
            className="w-full max-w-sm mx-auto cursor-pointer"
            size="lg"
          >
            Confirm Account
          </Button>

          <p className="text-sm text-gray-500">
            If you have any issue confirming your account,
            <br />
            please contact{' '}
            <a
              href="mailto:contact@project-short.com"
              className="underline hover:text-gray-700"
            >
              contact@project-short.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
